import './assets/style/index.scss'
import './assets/icons/index.js'

import TumengEditor from './packages/tumeng-editor/index.js'
import TumengDisplay from './packages/tumeng-display/index.js'
import TumengSvgIcon from './packages/svg-icon/index.js'
import TumengDraggable from './packages/tumeng-draggable/index.js'
import TumengText from './packages/tumeng-text/index.js'
import TumengTextEdit from './packages/tumeng-text-edit/index.js'
// 添加数字类型
import TumengNumber from './packages/tumeng-number/index.js'
import TumengNumberEdit from './packages/tumeng-number-edit/index.js'

// 添加线条类型
import TumengLine from './packages/tumeng-line/index.js'
import TumengLineEdit from './packages/tumeng-line-edit/index.js'

// 添加形状色块类型
import TumengBlock from './packages/tumeng-block/index.js'
import TumengBlockEdit from './packages/tumeng-block-edit/index.js'

import TumengMultiImg from './packages/tumeng-multi-img/index.js'
import TumengMultiImgEdit from './packages/tumeng-multi-img-edit/index.js'
import TumengVideo from './packages/tumeng-video/index.js'
import TumengAd from './packages/tumeng-ad/index.js'
import TumengQRCode from './packages/tumeng-qr-code/index.js'
import TumengBARCode from './packages/tumeng-bar-code/index.js'
import TumengPriceTag from './packages/tumeng-price-tag/index.js'
import TumengRuler from './packages/tumeng-ruler/index.js'
import TumengNavigator from './packages/tumeng-navigator/index.js'
import TumengAttrRow from './packages/tumeng-attr-row/index.js'
import TumengValuation from './packages/tumeng-valuation/index.js'
import TumengValuationEdit from './packages/tumeng-valuation-edit/index.js'

const components = [
  TumengPriceTag,
  TumengQRCode,
  TumengBARCode,
  TumengEditor,
  TumengDraggable,
  TumengDisplay,
  TumengSvgIcon,
  TumengText,
  TumengTextEdit,
  TumengNumber,
  TumengNumberEdit,
  TumengLine,
  TumengLineEdit,
  TumengBlock,
  TumengBlockEdit,
  TumengMultiImg,
  TumengMultiImgEdit,
  TumengVideo,
  TumengAd,
  TumengRuler,
  TumengNavigator,
  TumengAttrRow,
  TumengValuation,
  TumengValuationEdit
]

const install = function(Vue) {
  if (install.installed) {
    return
  }
  components.map(component => Vue.component(component.name, component))
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  TumengPriceTag,
  TumengQRCode,
  TumengBARCode,
  TumengEditor,
  TumengDraggable,
  TumengDisplay,
  TumengSvgIcon,
  TumengText,
  TumengTextEdit,
  TumengNumber,
  TumengNumberEdit,
  TumengLine,
  TumengLineEdit,
  TumengBlock,
  TumengBlockEdit,
  TumengMultiImg,
  TumengMultiImgEdit,
  TumengVideo,
  TumengAd,
  TumengRuler,
  TumengNavigator,
  TumengAttrRow,
  TumengValuation,
  TumengValuationEdit
}
